(ns practitest.frontend.sections.events
  (:require
   [ajax.core :as ajax] 
   [practitest.frontend.common.i18n :refer [get-translation] :as i18n] 
   [practitest.frontend.common.format-utils :as fu]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.events :as events]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]))

(defn- fetch-settings-fields [{db :db} [_]]
  {:http-xhrio
   {:method :get
    :uri (broutes/get-url "sections#settings_fields"
                          {:project_id (subs/get-current-project-id db)})
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success [::got-settings-fields]
    :on-failure [::api-error ::fetch-settings-fields {}]}})

(re-frame/reg-event-fx
 ::api-error
 (fn [{db :db} event-vec]
   (let [opts (nth event-vec 3 nil)
         message (when (map? opts) (:message opts))
         ;; http-xhrio appends the error response as the last element
         http-error (last event-vec)
         response (when (map? http-error) (:response http-error))
         errors (:errors response)]
     {:db (-> db
              (update :progress disj (nth event-vec 2))
              (assoc-in [:sections :is-saving] false))
      :dispatch [::notifications/error2
                 (if (seq errors)
                   (fu/format-server-error-message errors)
                   (or message (get-translation "sections.notify.generic-error" "Error happened during operation")))
                 {:id "api-error-message" :raw-html? true}]})))

(re-frame/reg-event-fx
 ::save-sections-failure
 (fn [{db :db} event-vec]
   (let [http-error (last event-vec)
         response (when (map? http-error) (:response http-error))
         blocked? (:blocked response)]
     (if blocked?
       {:db (-> db
                (update :progress disj (nth event-vec 2))
                (assoc-in [:sections :is-saving] false)
                (assoc-in [:sections :deletion-prevention-data] response))}
       {:dispatch (into [::api-error] (rest event-vec))}))))

(re-frame/reg-event-db
 ::close-deletion-prevention-modal
 (fn [db _]
   (assoc-in db [:sections :deletion-prevention-data] nil)))

(re-frame/reg-fx
 ::call-on-success
 (fn [on-success]
   (on-success)))

(re-frame/reg-event-fx
 ::save-sections-success
 (fn [{db :db} [_ on-success _response]]
   (cond-> {:db (-> db
                    (assoc-in [:sections :is-dirty] false)
                    (assoc-in [:sections :is-saving] false))
            :dispatch-n [[::events/fetch-fields true]
                         [::events/fetch-sections]
                         [::notifications/success2 (get-translation "sections.notify.saved" "Data was successfully saved")]]}
     on-success (assoc ::call-on-success on-success))))

(re-frame/reg-event-fx
 ::save-sections
 (fn save-sections [{db :db} [_ payload on-success]]
   {:http-xhrio
    {:method :post
     :uri (broutes/get-url "sections#update_entity_fields"
                           {:project_id (subs/get-current-project-id db)})
     :params payload
     :format (ajax/json-request-format)
     :response-format (ajax/json-response-format {:keywords? true})
     :on-success [::save-sections-success on-success]
     :on-failure [::save-sections-failure ::save-sections {:message (get-translation "sections.notify.error-saving" "Failed to save data")} :throw? true]}}))

(re-frame/reg-event-fx
 ::fetch-settings-fields
 fetch-settings-fields)

(defn- got-settings-fields [db [_ data]]
  (assoc db :settings-fields data))

(re-frame/reg-event-db
 ::got-settings-fields
 got-settings-fields)